import { useCallback } from 'react';
import { useEntityContext } from '@/hooks/entity-context.hook';
import type { EntitySummary } from '@/types/entity-context';

// Kept as a compatibility name for existing profile/sidebar components. The
// source of truth is now the canonical Entity API and active JWT context.
export type MyAccount = EntitySummary;

export function useMyAccounts() {
  const { entities, current, switchEntity, refreshEntities } = useEntityContext();

  const setActive = useCallback(
    async (entityId: string) => {
      if (entityId === current?.entityId) return current;
      const selected = await switchEntity(entityId);
      if (selected) window.location.assign('/dashboard');
      return selected;
    },
    [current, switchEntity],
  );

  const primary = entities.find((entity) => entity.id === current?.entityId) ?? null;

  return {
    accounts: entities,
    primary,
    reload: refreshEntities,
    setActive,
  };
}
